import { track } from "jiffy-analytics";

export const getTrackName = action => {
  const prefix = () => {
    if (document.querySelector(".js-buy-it-again-orders-modal-toggle")) return "orders";
    if (document.querySelector(".js-buy-it-again-favorite-modal-toggle")) return "favorite";
    return "common";
  };

  return `buy_it_again_${prefix()}_${action}`;
};

export const trackModalClose = props => {
  // Avoid auto-hide if new color is selected. Only manual closing
  if (props?.productId) track(getTrackName("close"), props);
};

export const trackModalOpen = props => {
  track(getTrackName("open"), props);
};

export const trackModalNewColorSelected = props => {
  track(getTrackName("new_color_selected"), props);
};

export const trackModalViewAllColors = props => {
  track(getTrackName("view_all_colors"), props);
};

export default {};
